<template>
 <div id="wrapper">
    <!-- <div id="mount"></div> -->
    <div id="lamp-wrapper">
      <div id="string"></div>
      <div id="top"></div>
      <div id="lamp"></div>
      <div id="bulb"></div>
      <div id="light"><div class="light"></div></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Lamp'
  }
</script>
  
<style lang="css">

  #wrapper {
    position: absolute;
    top: -170px;

    overflow: hidden;
    width: 100%;
    height: auto;

    z-index: 10000;

    user-select: none;
    pointer-events: none;
    /*mix-blend-mode: exclusion;*/
  }

  #lamp-wrapper {
    -webkit-transform-origin: top center;
    transform-origin: top center;
    -webkit-animation: lamp 4s infinite;
    animation: lamp 4s ease-in-out infinite;

    position: relative;
  }


  #mount, #string, #top, #lamp, #bulb, #light {
    position: relative;
    margin: 0 auto;
  }

  #string {
    z-index: 1;
    width: 4px;
    height: 500px;
    background: #1d1d1d;
    margin-top: -2px;
  }

  #top {
    width: 4px;
    height: 4px;
    border: 20px solid transparent;
    border-bottom: 20px solid #1d1d1d;
    margin-top: -24px;
    z-index: 3;
  }

  #lamp {
    z-index: 2;
    width: 140px;
    height: 50px;
    background: #3d3d3d;
    border-radius: 50% / 100%;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    margin-top: -3px;
    -webkit-box-shadow: inset 0 8px 30px #211;
    box-shadow: inset 0 8px 30px #211;
  }

  #bulb {
    z-index: 1;
    width: 40px;
    height: 20px;
    background: rgba(0,191,255, .05);
    border-radius: 50% / 100%;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: -5px;
    -webkit-box-shadow: 0 0 100px #FFF, inset 0 0 15px #000;
    box-shadow: 0 0 100px #FFF, inset 0 0 15px #000;
  }

  #light {
    width: 100vw;
    height: 640px;

    position: relative;

    margin-top: -18px;
  }

  .light {
    height: 800px;
    width: 800px;

    top: 110px;
    position: absolute;

    left: 50%;
    transform: translateX(-50%) rotate(45deg) ;
    /*background: linear-gradient(to bottom right, rgba(255,235,60,.6) , rgba(0,0,0,0), rgba(0,0,0,0));*/
    background: linear-gradient(to bottom right, rgba(255,255,255,.6) , rgba(0,0,0,0), rgba(0,0,0,0));
    filter: blur(5px);
  }
</style>





// WEBPACK FOOTER //
// src/components/library/lamp.vue